export default "__VITE_ASSET__De8S5H6J__"